import { WorkoutMode } from '@kinomap-dev/ng-ui-lib/core';
import { WorkoutSectionDataByMode } from '../../types/section.type';

/** Un champ de donnees d'une section : le type expose a l'UI et sa clef dans `data`. */
export type WorkoutModeField<M extends WorkoutMode> = {
    readonly type: WorkoutMode;
    readonly key: keyof WorkoutSectionDataByMode[M] & string;
};

/**
 * Pour chaque mode, la liste des champs stockes dans `data`.
 * La clef est typee par mode : une faute de frappe ou un champ oublie casse la compilation.
 */
export const WORKOUT_MODE_FIELDS: {
    readonly [M in WorkoutMode]: readonly WorkoutModeField<M>[];
} = {
    ftp: [{ type: 'ftp', key: 'ftp' }],
    watts: [{ type: 'watts', key: 'watts' }],
    res: [{ type: 'res', key: 'resistance' }],
    slope: [{ type: 'slope', key: 'slope' }],
    inc: [{ type: 'inc', key: 'incline' }],
    spd: [{ type: 'spd', key: 'speed' }],
    incSpd: [
        { type: 'inc', key: 'incline' },
        { type: 'spd', key: 'speed' },
    ],
};

/** Mode utilise quand aucun mode n'est defini. */
export const DEFAULT_WORKOUT_MODE_FIELDS_MODE: WorkoutMode = 'res';
